import { isArray, map } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import React from 'react';

import { MappedQuestion } from '../../types/question';

// the order of the properties isn't necessary, but makes schema verifying tools output clearer to read
// the schema can be verified with: https://search.google.com/test/rich-results and https://validator.schema.org/
const buildQuestionAndAnswer = (FAQ: MappedQuestion) => {
  const { body, title } = FAQ;
  return {
    '@type': 'Question',
    name: title,
    // eslint-disable-next-line sort-keys
    acceptedAnswer: {
      '@type': 'Answer',
      text: isArray(body) ? portableTextToPlain(body) : body,
    },
  };
};

const FAQStructuredContentBlock = ({ faqs }: { faqs: MappedQuestion[] | undefined }) => {
  if (!faqs) return null;
  const builtQuestionsAndAnswers = map(buildQuestionAndAnswer, faqs);
  return (
    <script
      type="application/ld+json"
      data-testid="faq-schema"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: builtQuestionsAndAnswers,
        }),
      }}
    />
  );
};

export default FAQStructuredContentBlock;
